// Generated by scripts/generate-environment.mjs — do not edit by hand.
export const environment = {
  production: true,
  SITE_URL: "https://gabalirealty.com",
  API_URL: "https://gabali-backend-00f000eaa8dd.herokuapp.com/api/",
  adminEmails: ["gabalidevelopment@gmail.com","gabalirealty@gmail.com"],
  MAPS_KEY: "AIzaSyC_4HEYuvTU-4kgs5V1GE0Vj57Mkuf4sTE",
  MAPS_MAP_ID: "a0f23dfcca37443bfe7174fc",
  FACEBOOK_APP_ID: "918795468655931",
  firebaseConfig: {
    apiKey: "AIzaSyDZwBtquJ7EfCkWfOJM0eZIebmRBIEMNXI",
    authDomain: "gabali-realty.firebaseapp.com",
    databaseURL: "https://gabali-realty.firebaseio.com",
    projectId: "gabali-realty",
    storageBucket: "gabali-realty.appspot.com",
    messagingSenderId: "332676127797",
    appId: "1:332676127797:web:3763d64cecdb3a127b257c",
  },
};
